import { TableTabs } from "@/components/DataTable/TableTabs";
import React from "react";
import { BulkMessageTableBase } from "./BulkMessageTableBase";
import { useTranslation } from "react-i18next";
import { BulkMessageSendStatusEnum } from "@/__generated__/types";

export const BulkMessageTable = () => {
  const { t } = useTranslation();
  return (
    <section>
      <TableTabs
        activeTab={0}
        tabs={[
          {
            label: t("bulkMessaging.table.active"),
            children: (
              <BulkMessageTableBase
                sendStatus={BulkMessageSendStatusEnum.Active}
              />
            ),
          },
          {
            label: t("bulkMessaging.table.scheduled"),
            children: (
              <BulkMessageTableBase
                sendStatus={BulkMessageSendStatusEnum.Scheduled}
              />
            ),
          },
          {
            label: t("bulkMessaging.table.draft"),
            children: (
              <BulkMessageTableBase
                sendStatus={BulkMessageSendStatusEnum.Draft}
              />
            ),
          },
          {
            label: t("bulkMessaging.table.completed"),
            children: (
              <BulkMessageTableBase
                sendStatus={BulkMessageSendStatusEnum.Sent}
              />
            ),
          },
        ]}
      />
    </section>
  );
};
